var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinkRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 278,
    viewBox: "0 0 262 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43237 1.31433C85.2236 17.273 172.489 28.5116 260.878 34.8051V259.014C172.489 262.498 85.2236 268.567 1.43237 277.22V1.31433Z",
    fill: "#FE8291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94311 1.98865C85.4277 17.835 172.284 29.0735 260.367 35.3671V258.452C172.284 261.936 85.4277 268.005 1.94311 276.658V1.98865ZM0.921265 0.640015V277.895C84.0993 269.241 171.263 263.06 261.389 259.576V34.3556C171.263 27.9496 84.0993 16.4863 0.921265 0.640015Z",
    fill: "#FE8291"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkRectangle);
export default __webpack_public_path__ + "static/media/PinkRectangle.2a3ebf2af7243fba817e313463d48528.svg";
export { ForwardRef as ReactComponent };